import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FadeUp, Overline } from "@/components/motion";
import { useContent } from "@/lib/content";

const FAQS = [
  {
    q: "Wann kann ich ein- und auschecken?",
    a: "Einfach jederzeit persönlich bei uns vor Ort einchecken. Ihr Zimmer steht ab 15:00 Uhr bereit, am Abreisetag bitten wir um Check-out bis 11:00 Uhr.",
  },
  {
    q: "Wie kann ich bezahlen?",
    a: "Sie wählen bei der Buchung: bequem online per Kreditkarte, PayPal u. a. (Stripe) oder klassisch per Überweisung. Bei Überweisung reservieren wir Ihr Zimmer 7 Tage.",
  },
  {
    q: "Gibt es Parkplätze?",
    a: "Ja — kostenfreie Hotelparkplätze direkt am Haus, mitten in der Innenstadt.",
  },
  {
    q: "Gibt es Frühstück?",
    a: "Ja, unser reichhaltiges Frühstücksbuffet können Sie zu Ihrem Aufenthalt zubuchen — von Gästen regelmäßig gelobt. Restaurant und Bar befinden sich im Haus.",
  },
  {
    q: "Wie komme ich zu den Wildpferden?",
    a: "Die Merfelder Bruch erreichen Sie vom Hotel aus in nur 10 Autominuten. Tipps zu Beobachtungspunkten und Radwegen bekommen Sie von unserem Team.",
  },
  {
    q: "Darf ich mein Haustier mitbringen?",
    a: "Haustiere sind bei uns leider nicht erlaubt — wir bitten um Verständnis.",
  },
  {
    q: "Kann ich kostenfrei stornieren?",
    a: "Bis 48 Stunden vor Anreise stornieren Sie kostenfrei. Danach berechnen wir 80 % des Übernachtungspreises.",
  },
];

export default function FaqSection() {
  const c = useContent();
  const faqs = c.faq_items?.length ? c.faq_items : FAQS;
  return (
    <section id="faq" className="py-24 lg:py-32 bg-cream" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        <FadeUp className="text-center">
          <Overline>Gut zu wissen</Overline>
          <h2 className="mt-4 font-serif font-medium text-3xl sm:text-4xl lg:text-5xl tracking-tight text-forest">
            Häufige Fragen
          </h2>
        </FadeUp>
        <FadeUp delay={0.15} className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="bg-white rounded-2xl border border-forest/10 px-6 data-[state=open]:border-gold/60 transition-colors duration-300"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-lg sm:text-xl font-semibold text-forest hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-ink/65 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </FadeUp>
      </div>
    </section>
  );
}
